import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import { getAllUsers } from "../../../redux/requests/AdminRequests";
import AddOperatorModal from "../../UI/add-operator-modal/AddOperatorModal";
import useOutsideAlerter from "../../../hooks/UseOutSide";

const Operator = () => {
  const users = useAppSelector((state) => state.admin.users);
  const dispatch = useAppDispatch();

  const { isShow, setIsShow, modalRef } = useOutsideAlerter(false);

  useEffect(() => {
    dispatch(getAllUsers());
  }, []);

  return (
    <div className="flex flex-col">
      <button
        className="text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none self-end"
        onClick={() => setIsShow(true)}
      >
        Добавить
      </button>
      <div className="relative overflow-x-auto bg-neutral-primary-soft shadow-xs rounded-base border border-default">
        <table className="w-full text-sm text-left rtl:text-right text-body">
          <thead className="bg-neutral-secondary-soft border-b border-default">
            <tr>
              <th scope="col" className="px-6 py-3 font-medium">
                ID
              </th>
              <th scope="col" className="px-6 py-3 font-medium">
                username
              </th>
              <th scope="col" className="px-6 py-3 font-medium">
                fullname
              </th>
              <th scope="col" className="px-6 py-3 font-medium">
                organization
              </th>
              <th scope="col" className="px-6 py-3 font-medium">
                admin
              </th>
              <th scope="col" className="px-6 py-3 font-medium">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => {
              return (
                <tr
                  className="odd:bg-neutral-primary even:bg-neutral-secondary-soft border-b border-default"
                  key={index}
                >
                  <td className="px-6 py-4">{user.id}</td>
                  <td className="px-6 py-4">{user.username}</td>
                  <td className="px-6 py-4">{user.fullname}</td>
                  <td className="px-6 py-4">{user.organization.name}</td>
                  <td className="px-6 py-4 flex justify-center align-middle">
                    {user.is_admin ? (
                      <svg
                        width="20px"
                        height="20px"
                        viewBox="0 0 16 16"
                        id="meteor-icon-kit__solid-check-circle-s"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16zM5.70711 7.2929C5.31658 6.9024 4.68342 6.9024 4.29289 7.2929C3.90237 7.6834 3.90237 8.3166 4.29289 8.7071L6.2929 10.7071C6.6834 11.0976 7.3166 11.0976 7.7071 10.7071L11.7071 6.7071C12.0976 6.3166 12.0976 5.68342 11.7071 5.29289C11.3166 4.90237 10.6834 4.90237 10.2929 5.29289L7 8.5858L5.70711 7.2929z"
                          fill="#758CA3"
                        />
                      </svg>
                    ) : (
                      <></>
                    )}
                  </td>
                  <td className="px-6 py-4">
                    <a
                      href="#"
                      className="font-medium text-fg-brand hover:underline"
                    >
                      Edit
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <AddOperatorModal
        isActive={isShow}
        setIsActive={setIsShow}
        ref={modalRef}
      />
    </div>
  );
};

export default Operator;
